export function openModal(text, author = null) {
  const modal = document.createElement('div');
  modal.classList.add('basic-modal', 'card-modal', 'modal-active');

  modal.innerHTML = `
    <div class='content'>
      <div class='line'>
        <img class='logo' src='static/img/5p-logo-no-bg-width-100.webp'>
        <span class='close'>&times;</span>
      </div>

      <p class='text'>${text}</p>

      ${author ? `<p class='author'>${author}</p>` : ''}

    </div>
  `;

  document.body.appendChild(modal);
  document.body.classList.add('blocked');

  modal.querySelector('.close').addEventListener('click', () => {
    modal.remove();
    document.body.classList.remove('blocked');
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.remove();
      document.body.classList.remove('blocked');
    }
  });
}